import Navbar from './components/Layout/Navbar'
import Home from './components/Sections/Home'
import GodParent from './components/Sections/GodParent'
import Gallery from './components/Sections/Gallery'
import Settings from './components/Sections/Settings'
import HealthProtocol from './components/Sections/HealthProtocol'
import GiftIdeas from './components/Sections/GiftIdeas'
import RSVP from './components/Sections/RSVP'
import ScrollUp from './components/Layout/ScrollUp'
import Footer from './components/Layout/Footer'

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Home />
        <Settings />
        <Gallery />
        <HealthProtocol />
        <GiftIdeas />
        <RSVP />
      </main>
      <ScrollUp />
      <Footer />
    </>
  )
}

export default App
